module.exports = __webpack_public_path__ + "static/video-difusion-1140-0f367204b3dc430dc27ae93eedb8412c.jpg";